/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const TeamUsers = {

	deleteTeamUser (context, teamUserId, onSuccess, onError, options) {
		Api.delete(context,
			"/team-users/team-user"
			+ "?teamUserId=" + teamUserId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getTeamUsers (context, teamId, onSuccess, onError, options) {
		Api.get(context,
			"/team-users/team-users"
			+ "?teamId=" + teamId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getTeamUsersAvailable (context, teamId, onSuccess, onError, options) {
		Api.get(context,
			"/team-users/team-users-available"
			+ "?teamId=" + teamId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getTeamUsersToAdd (context, teamId, onSuccess, onError, options) {
		Api.get(context,
			"/team-users/team-users-to-add"
			+ "?teamId=" + teamId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postTeamUser (context, contestUserId, teamId, onSuccess, onError, options) {
		Api.post(context,
			"/team-users/team-user"
			+ "?contestUserId=" + contestUserId
			+ "&teamId=" + teamId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putPromoteToLeader (context, teamUserId, onSuccess, onError, options) {
		Api.put(context,
			"/team-users/promote-to-leader"
			+ "?teamUserId=" + teamUserId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
